import { setContent, setOpen } from "shared/redux/reducers/PopupSlice";
import { SetState } from "shared/types/general";
import Error from "shared/ui/Error";

export function showError(e: any, dispatch: any) {
  dispatch(setOpen(true));
  dispatch(
    setContent(
      <Error
        text={
          e.response?.data?.error
            ? e.response.data.error
            : "Что-то пошло не так"
        }
      />
    )
  );
}
